import { render } from "./OtiActionsSmall.vue?vue&type=template&id=b88c5502&scoped=true"
import script from "./OtiActionsSmall.vue?vue&type=script&lang=js"
export * from "./OtiActionsSmall.vue?vue&type=script&lang=js"

import "./OtiActionsSmall.vue?vue&type=style&index=0&id=b88c5502&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Usuario\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b88c5502"]])

export default __exports__